import { ActionConfig } from "@Actions/action";
import { Actions } from "@Context/common/general/context";
import { isArray, isEqual } from "lodash-es";

// Takes the routes from the router and adds them as a array of keys to the app state
const routeTracker = (routes: React.ReactElement, availableRoutes: string[], dispatch:(config: ActionConfig) => Promise<void> ) => {
    let routesArray: string[] = [];
    routes.props.children.forEach((childRoutes: any) => {
        
        if(isArray(childRoutes)) {
        childRoutes.forEach((childRoute: any) => {
            routesArray.push(childRoute.props.path);
        });
        };
    });

    if(!isEqual(availableRoutes, routesArray)) {
        dispatch({ 
            type: Actions.CoreActions.UpdateState,
            payload: {
                app: {
                    availableRoutes: routesArray
                }
            } 
        });
    }

    return routes;
}

export default routeTracker;